export const themeVariables = [
	'unified-search-bg-color',
	'applicationLogoUrl',
	'action-btn-color',
	'btn-color',
	'header-icon-color',
	'body-icon-color',
	'body-text-color',
	'content-icon-color',
	'content-text-color',
	'active-color',
	'header-bg-color',
	'body-bg-color',
	'content-bg-color',
	'success-color',
	'warning-color',
	'info-color',
	'error-color',
	'default-font-color',
	'header-text-color',
	'palette-color1',
	'palette-color2',
	'palette-color3',
	'palette-color4',
	'palette-color5',
	'palette-color6',
	'palette-color7',
	'palette-color8',
	'palette-color9',
	'palette-color10',
	'palette-color11',
	'palette-color12',
	'base-layout-color',
	'icons-font-path',
] as const;

export const calculatedVariables = [
	'active-text-color',
	'content-computed-color1',
	'content-computed-color2',
	'content-computed-color3',
	'bg-muted-color',
	'disabled-text-color',
	'muted-text-color',
	'content-border-color',
	'action-btn-text-color',
	'header-active-color',
	'validation-success-color',
	'validation-error-color',
	'validation-warning-color',
	'validation-info-color',
	'message-text-color',
	'message-success-bg-color',
	'message-info-bg-color',
	'message-warning-bg-color',
	'message-error-bg-color',
	'muted-text-color',
	'input-border-color',
	'input-border-color-hover',
	'error-text-color',
	'action-btn-color-hover',
	'action-btn-color-focus',
	'border-radius',
	'success-text-color',
	'info-text-color',
	'warning-text-color',
	'faded-color',
	'fadest-color',
	'fadest-graphics-color',
	'disabled-icon-color',
	'supplementary-bg-half',
	'supplementary-bg-color',
	'supplementary-bg-color-enhanced',
	'supplementary-bg-color-enhanced2',
	'supplementary-bg-color-10per',
	'supplementary-bg-color-16per',
	'content-border-color-supplementary',
	'content-border-color-enhanced',
	'body-muted-text-color',
	'body-computed-color1',
	'body-computed-color2',
	'body-computed-color3',
	'error-text-color-hover',
	'error-text-color-ripple',
	'error-color-near-text',
	'error-color-near-bg',
	'content-hint-color',
	'body-border-color',
	'scrollbar-color',
	'scrollbar-color-active',
	'scrollbar-color-dimmed',
	'content-computed-color_8per',
	'content-computed-color_12per',
	'content-computed-color_16per',
	'content-computed-color_20per',
	'content-computed-color_27per',
	'content-computed-color_36per',
	'content-computed-color_38per',
	'content-computed-color_40per',
	'content-computed-color_67per',
	'content-computed-color_77per',
	'content-computed-color_80per',
	'content-computed-color_92per',
	'content-text-color-hue',
	'content-text-color-saturation',
	'content-bg-color-hue',
	'content-bg-color-saturation',
	'header-computed-color1',
	'header-computed-color2',
	'header-computed-color3',
	'breadcrumbs-color',
	'enhanced-contrast-3',
	'enhanced-contrast-4_5',
	'enhanced-contrast-7',
	'enhanced-contrast-max',
	'enhanced-contrast-active-color-fallback',
	'enhanced-contrast-action-btn-color',
	'unified-search-text-color',
	'btn-text-color',

	//TODO: to refactor
	'content-widget-view-board-contrast-warning',
	'qf-yellow',
	'navigation-config-btn-icon-color',
	'content-icon-color-lightness',
] as const;

export const allVariables = [...themeVariables, ...calculatedVariables] as const;

export type ThemeVariable = (typeof themeVariables)[number];
export type Variable = (typeof allVariables)[number];

export type Theme = Record<Variable, string> & {
	id: string;
	isDarkTheme: boolean;
	isContrastTheme: boolean;
};

export interface ThemeRecord {
	id: string;
	title: string;
	active: boolean;
	isContrast: boolean;
}

export type ThemeParameter = { Key: ThemeVariable; Value: string };
export type ThemeParameterDTO = { Key: ThemeVariable; Value: unknown };
export type ThemeParametersDTO = ThemeParameterDTO[];
export type AvailableThemesDTO = { ObjectId: string; Title: string; Default?: boolean; IsContrast?: boolean }[];
